import jscookie from 'js-cookie';
import _ from 'lodash';

const _mapValuesDeep = (obj, mapper, keyPath) => {
    if (typeof obj !== 'object') {
        return;
    }

    _.keys(obj).forEach(key => {
        const value = obj[key];
        const firstKeyPath = (_.isEmpty(keyPath) ? key : `${keyPath}.${key}`);
        const newValue = mapper({value, key, keyPath:firstKeyPath, obj});
        if (typeof newValue !== 'undefined') {
            if (_.isNull(newValue)) {
                delete obj[key];
            } else {
                try {
                    obj[key] = newValue;
                } catch (e) {
                    console.error(e);
                }
                if (_.isObject(obj[key])) {
                    const nextKeyPath = _.isEmpty(keyPath) ? key : `${keyPath}.${key}`;
                    _mapValuesDeep(obj[key], mapper, nextKeyPath);
                }
            }
        } else {
            if (_.isArray(value)) {
                value.forEach((v, idx) => {
                    const nextKeyPath = _.isEmpty(keyPath) ? `${key}[${idx}]` : `${keyPath}.${key}[${idx}]`;
                    _mapValuesDeep(v, mapper, nextKeyPath);
                });
            } else if (_.isObject(value)) {
                const nextKeyPath = _.isEmpty(keyPath) ? key : `${keyPath}.${key}`;
                _mapValuesDeep(value, mapper, nextKeyPath);
            } 
        }
    });

};

export const mapValuesDeep = (object, mapper) => {
    const cloneObject = _.cloneDeepWith(object);
    _mapValuesDeep(cloneObject, mapper, '');
    return cloneObject;
};

export const decodeHTML = (encodeHTML = "") => {
    return encodeHTML
        .replace(/&amp;/ig, "&")
        .replace(/&nbsp;/ig, " ")
        .replace(/&lt;/ig, "<")
        .replace(/&gt;/ig, ">")
        .replace(/&quot;/ig, "\"")
        .replace(/&apos;/ig, "'"); // 转换字符串中的"'"符号
};

export const isEmptyData = (obj) => {
    if (obj === undefined || obj === null || obj === "")
        return true;
    for (let item in obj) {
        return false;
    }
    if (typeof obj === 'number')
        return false;
    return true;
};

export const getDateTimeString = (dateInt) => {
    let date = new Date(dateInt);
    return date.getFullYear() + '-' +
        (date.getMonth() + 1) + '-' +
        date.getDate() + ' ' +
        date.getHours() + ':' +
        date.getMinutes() + ':' +
        date.getSeconds();
};

export const getDateString = (dateInt) => {
    let date = new Date(dateInt);
    return date.getFullYear() + '-' +
        (date.getMonth() + 1) + '-' +
        date.getDate();
};

export const joinRouteTitles = (matchResults) => {
    let title;
    const lastOne = matchResults[matchResults.length-1];
    if (lastOne.route.title) {
        const titles = [];
        for (let i = matchResults.length-1; i >= 0; i-- ) {
            const r = matchResults[i];
            if (r.route.title) {
                titles.push(r.route.title);
            }
        }
        title = titles.join('-');
    }
    return title;
};


export const resolveUrl = function(uri, params, host) {
    let url = `${host}${uri}`;

    let query = '';
    Object.keys(params).forEach(key => {
        const val = typeof(params[key]) === 'object' ?
            JSON.stringify(params[key]) : params[key];
        if (query.length > 0) {
            query += '&';
        }
        query += `${key}=${val}`;
    });
    return query === '' ?
        encodeURI(`${url}`) :
        encodeURI(`${url}?${query}`);
};

export const cookie = function() {
    if (typeof(document) === 'undefined') {
        return { clear:()=>{}, remove:()=>{}, add:()=>{}, };
    }
    const _cookie = {
        clear: () => {
            var keys = Object.keys(jscookie.get());
            keys.forEach(key => jscookie.remove(key));
        },
        remove: name => {
            jscookie.remove(name);
        },
        add: (name, value) => {
            if (name) {
                jscookie.set(name, value);
            }
        }
    };
    return _cookie;
}();

export const uuid = function () {
    let uuid = '';
    const s4 = function () {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    };
    for (let i = 0; i < 8; i++) {
        uuid += s4();
    }
    return uuid;
};

export const toUpperCaseFirst = function(str) {
    return str.substr(0, 1).toUpperCase() + str.substr(1);
};
export const toLowerCaseFirst = function(str) {
    return str.substr(0, 1).toLowerCase() + str.substr(1);
};


// WEBPACK FOOTER //
// ./src/utils/helper.js